export default __webpack_public_path__ + "static/media/background.c3cfb7d8.jpg";